import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAFt_iau8cimq3jF5Y_hezzv958edyPHIk",
  authDomain: "arcbolt-237cf.firebaseapp.com",
  projectId: "arcbolt-237cf",
  storageBucket: "arcbolt-237cf.firebasestorage.app",
  messagingSenderId: "733616619986",
  appId: "1:733616619986:web:5128a53b9418e68e69480b"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
export const db = getFirestore(app);
export default app;